export default __webpack_public_path__ + "static/media/selected-list.6ed7ae4d.svg";